<template>
  <oie-product-variant-shell v-if="currentProduct" :index="product.id">
    <template v-slot:default="slotProps">
      <oie-product-variants
        :apply-article-number-shadow="slotProps.applyArticleNumberShadow"
        :apply-stock-price-shadow="slotProps.applyStockPriceShadow"
        :product="currentProduct"
        :product-id="product.id"
        :type-of-listing="typeOfListing"></oie-product-variants>
    </template>
  </oie-product-variant-shell>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    typeOfListing: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      products: []
    }
  },
  computed: {
    ...mapGetters('ui', ['useVat']),
    ...mapGetters('commerce', ['currentProduct'])
  },
  mounted() {
    this.products = this.products.concat(this.product)
  }
}
</script>
